var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/flag-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1992 7.16L7.19922 3.7V2.75C7.19922 2.34 6.85922 2 6.44922 2C6.03922 2 5.69922 2.34 5.69922 2.75V21.25C5.69922 21.66 6.03922 22 6.44922 22C6.85922 22 7.19922 21.66 7.19922 21.25V17.29L15.4192 13.23C15.4192 13.23 15.4192 13.23 15.4292 13.23C17.0892 12.37 17.9792 11.26 17.9292 10.09C17.8792 8.92 16.9092 7.88 15.1992 7.16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.bf8f2436814e18b6c5bd4ae03763800e.svg";
export { ForwardRef as ReactComponent };